import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TopMenu from "../../components/TopMenu/TopMenu";
import BottomNav from "../../components/BottomNav/BottomNav";
import { TimezoneSelector } from "../../components/TimezoneSelector/TimezoneSelector";
import "./configuration.css";

const languages = [
  { code: "en", key: "english", flag: "🇺🇸" },
  { code: "pt", key: "portuguese", flag: "🇧🇷" },
  { code: "es", key: "spanish", flag: "🇪🇸" },
  { code: "it", key: "italian", flag: "🇮🇹" },
  { code: "fr", key: "french", flag: "🇫🇷" }
];

export default function Configuration() {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(i18n.language);

  useEffect(() => {
    setSelectedLang(i18n.language);
  }, [i18n.language]);

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang);
    setSelectedLang(lang); // Force immediate state update
  };

  return (
    <div className="configuration-page">
      <TopMenu />
      <main className="configuration-container">
        <h1 className="configuration-title">{t('pages.configuration.title')}</h1>
        <p className="configuration-description">{t('pages.configuration.selectLanguage')}</p>
        <div className="language-grid">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`language-card ${selectedLang === lang.code ? "active" : ""}`}
              aria-pressed={selectedLang === lang.code}
            >
              <span className="language-flag">{lang.flag}</span>
              <span className="language-name">{t(`pages.configuration.${lang.key}`)}</span>
              {selectedLang === lang.code && <span className="checkmark">✓</span>}
            </button>
          ))}
        </div>

        {/* TIMEZONE SECTION */}
        <div className="configuration-section">
          <h2 className="configuration-section-title">{t('pages.configuration.timezoneLabel')}</h2>
          <p className="configuration-description">{t('pages.configuration.selectTimezone')}</p>
          <TimezoneSelector />
          <p className="configuration-help-text">{t('pages.configuration.timezoneHelp')}</p>
        </div>
      </main>
      <BottomNav />
    </div>
  );
}